import { Injectable } from '@angular/core';
import { User } from '../../../models/user.model';
import { HttpClient } from '@angular/common/http';
import { ACCESS_TOKEN_NAME } from '../../../common/constants/auth.constants';

@Injectable()
export class AuthApi {
  constructor(protected readonly httpClient: HttpClient) {}
  async login(email: string, password: string) {
    const response = (await this.httpClient
      .post('auth/login', { email, password })
      .toPromise()) as { [ACCESS_TOKEN_NAME]: string; user: User };
    return response;
  }
}
